// 函数防抖
export function debounce(fn, wait) {
    let timeout = null;
    wait = wait || 600;
    return function () {
      let that = this;
      if(timeout !== null)   clearTimeout(timeout);  
      timeout = setTimeout(() => {
        fn.apply(that);
      }, wait);
    }    
}

/* 节流 */
export function throttle(func, delay) {
  let time = null;
  return function () {
    let args = Array.from(arguments);
    if (time === null) {
      time = setTimeout(() => {
        func(...args);
        clearTimeout(time);
        time = null;
      }, delay);
    }
  };
}


// WEBPACK FOOTER //
// ./src/tool/shake.js